module.exports = __webpack_public_path__ + "static/media/Georgia.9a64183b.ttf";